export function capitalizeFirstWord(word) {
    return word && word.trim().charAt(0).toUpperCase() + word.substring(1);
}
